import React from 'react';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import { GenericErrorPage } from '@locus-taxy/encore-ui-toolkit';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const handleRetry = () => {
    // Go back in browser history
    window.history.back();
  };

  return (
    <GenericErrorPage
      title={t('dashboard.notFound.title', 'Page Not Found')}
      message={t(
        'dashboard.notFound.message',
        "The page you're looking for doesn't exist or has been moved. Please check the URL or go back to the previous page."
      )}
      showRetry={true}
      onRetry={handleRetry}
      retryButtonText={t('dashboard.notFound.goBackButton', 'Go Back')}
    />
  );
};
